var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 19,
    viewBox: "0 0 67 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26385",
    d: "M2 1H33.5V18H2C1.17157 18 0.5 17.3284 0.5 16.5V2.5C0.5 1.67157 1.17157 1 2 1Z",
    fill: "#7C7C7C",
    stroke: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26386",
    d: "M33.5 1H65C65.8284 1 66.5 1.67157 66.5 2.5V16.5C66.5 17.3284 65.8284 18 65 18H33.5V1Z",
    fill: "white",
    stroke: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23987",
    x: 42,
    y: 5.5,
    width: 16.2388,
    height: 8,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23985",
    x: 9,
    y: 5.5,
    width: 16.2388,
    height: 8,
    fill: "#D3D3D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio3A);
export default __webpack_public_path__ + "static/media/Radio-3A.2d4b45eda93cf848af5f07cfefd2d11d.svg";
export { ForwardRef as ReactComponent };